//These are the important styles to make sticky column pinning work!
//Apply styles like this using your CSS strategy of choice with this kind of logic to head cells, data cells, footer cells, etc.
import type { CSSProperties } from 'react';

import type { Column } from '@tanstack/react-table';

//View the index.css file for more needed styles such as border-collapse: separate
const getCommonPinningStyles = <TData>(
  column: Column<TData, unknown>
): CSSProperties => {
  let filter;
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn =
    isPinned === 'left' && column.getIsLastColumn('left');
  const isFirstRightPinnedColumn =
    isPinned === 'right' && column.getIsFirstColumn('right');

  if (isLastLeftPinnedColumn) {
    filter = 'drop-shadow(1px 0 0px #DDE5ED)';
  } else if (isFirstRightPinnedColumn) {
    filter = 'drop-shadow(-1px 0px 0px #DDE5ED)';
  } else {
    filter = undefined;
  }

  return {
    filter,
    left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
    right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
    position: isPinned ? 'sticky' : 'relative',
    width: column.getSize(),
    backgroundColor: isPinned ? 'white' : undefined,
    zIndex: isPinned ? 10 : 0,
  };
};

export { getCommonPinningStyles };
